import { registerComponent, asyncRequest, loading } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "product-form",
  class ProductForm extends WYATTElement {
    constructor() {
      super();

      this.form = this.querySelector("form");

      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }

    handleSubmit(event) {
      event.preventDefault();

      loading.add(this);
      this.addToCart();
    }

    /**
     * Build the `/cart/add.js` payload from the product form.
     * When `WYATT.PreferredStores.selectedStore.store_number` is set, includes
     * it as `attributes.store` (form `attributes[...]` inputs still merge in).
     *
     * @returns {object}
     */
    getBody() {
      const formData = new FormData(this.form);

      const propertiesRegex = /properties\[(.*?)\]/;
      const attributesRegex = /attributes\[(.*?)\]/;

      const storeNumber = WYATT.PreferredStores?.selectedStore?.store_number;

      const body = {
        items: [
          {
            id: formData.get("id"),
            quantity: formData.get("quantity") || 1,
            properties: {},
          },
        ],
        sections: WYATT.Cart.getSectionNames(),
        sections_url: WYATT.routes.cart_url,
        attributes: storeNumber ? { store: storeNumber } : {},
      };

      // Add cart attributes or line item properties to body
      Array.from(formData).forEach(([name, value]) => {
        const propertiesMatch = propertiesRegex.exec(name);
        const attributesMatch = attributesRegex.exec(name);

        if (propertiesMatch && propertiesMatch.length > 1) {
          body.items[0].properties[propertiesMatch[1]] = value;
        }

        if (attributesMatch && attributesMatch.length > 1) {
          body.attributes[attributesMatch[1]] = value;
        }
      });

      return body;
    }

    async addToCart() {
      await WYATT.Cart.ready;

      const body = this.getBody();
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      const addedToCartResponse = await asyncRequest(
        `${WYATT.routes.cart_add_url}.js`,
        options,
        {
          messageOptions: {
            minDelay: 6000,
            appendPoint:
              '[data-mini-cart][active="true"] [data-dialog-messages], #page-messages',
          },
        },
      );

      if (addedToCartResponse) {
        await this.handleSuccessfulAdd(addedToCartResponse);
      } else {
        await this.handleUnsuccessfulAdd();
      }

      loading.remove(this);
    }

    async handleSuccessfulAdd(response) {
      const data = JSON.parse(response);
      const result = await WYATT.Cart.applyAddResponse(data);

      if (result?.sections) {
        this.publish(
          WYATT.PubSub.events.updateDOM,
          WYATT.Cart.sectionUpdates(result.sections),
        );
      }

      if (!this.config.skipMiniCart) {
        this.publish(WYATT.PubSub.events.addToCart);
      } else {
        WYATT.Cart.provideCartCountFeedback();
      }
    }

    async handleUnsuccessfulAdd() {
      // Error body has no cart payload; Shopify may still have added some stock.
      await WYATT.Cart.reseed();

      const sectionsData = await asyncRequest(
        `${window.location.pathname}?sections=${WYATT.Cart.getSectionNames()}`,
        {},
        {
          responseFormat: "json",
        },
      );

      if (sectionsData) {
        this.publish(
          WYATT.PubSub.events.updateDOM,
          WYATT.Cart.sectionUpdates(sectionsData),
        );
      }

      if (!this.config.skipMiniCart) {
        this.publish(WYATT.PubSub.events.addToCart);
      }
    }
  },
);
